import {
  ArrowSortDownFilled,
  ArrowSortRegular,
  ArrowSortUpFilled,
} from "@fluentui/react-icons";
import { SortDirection } from "@tanstack/react-table";

function SortIconSelector({ sortValue }: { sortValue: false | SortDirection }) {
  return sortValue ? (
    sortValue === "desc" ? (
      <ArrowSortUpFilled className="arrow-sort-up-filled" fontSize={18} />
    ) : (
      <ArrowSortDownFilled className="arrow-sort-down-filled" fontSize={18} />
    )
  ) : (
    <ArrowSortRegular className="arrow-sort-regular" fontSize={18} />
  );
}

export default SortIconSelector;
